/* eslint-disable no-console */
import Vue from "vue";
import Router from "vue-router";
import routes from "vue-auto-routing";
import store from "../store";
import firebase from "firebase/app";
import "firebase/auth"; // for authentication
import "firebase/firestore";
import "firebase/functions";
import _ from "lodash";
import vueHeadful from "vue-headful";

Vue.component("vue-headful", vueHeadful);

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...routes,
    {
      path: "*",
      component: () => import("@/pages/404.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {

  store.dispatch("Utils/set_annee_actuelle");
  firebase.auth().onAuthStateChanged((user) => {
    let self = this;
    if (user) {
      //define user
      const uid = user.uid;
      //get user from users colection
      var docRefUsers = firebase.firestore().collection("users").doc(uid);
      var docRefGroupes = firebase.firestore().collection("groupes").doc(uid);
      docRefUsers
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let userFromCollectionUsers = doc.data();
            const fusionnedUser = _.merge(userFromCollectionUsers, user);
            store.dispatch("Auth/setUser", fusionnedUser);

            if (!fusionnedUser.isAnimateur) {
              store.dispatch("Utils/GetArrayRegions", fusionnedUser, {
                root: true,
              });
              store.dispatch("Utils/GetDistrictsDuSuperviseur", fusionnedUser, {
                root: true,
              });
            }

            /// ici  commence ///

            firebase
              .auth()
              .currentUser.getIdTokenResult()
              .then((tokenResult) => {
                //console.log("je suis connecté");
                store.dispatch("Auth/setRoleStates", {
                  mutation: "SET_AUTHENTICATED",
                });
                var isAnimateur = store.state.Auth.user.isAnimateur;
                var role = store.state.Auth.user.role;
                var claims = { [role]: true };

                if (isAnimateur) {
                  store.dispatch("Auth/setRoleStates", {
                    mutation: "SET_IS_ANIMATEUR",
                  });
                  if (userFromCollectionUsers.projetSelected) {
                    store.dispatch(
                      "Auth/setProjectSelected",
                      userFromCollectionUsers.projetSelected
                    );
                  } else {
                    const projets = Array.isArray(userFromCollectionUsers.projets)
                      ? userFromCollectionUsers.projets
                      : [];
                    if (projets.length > 0) {
                      store.dispatch("Auth/setProjectSelected", projets[0]);
                      var objet = {
                        userId: user.uid,
                        project: projets[0],
                      };
                      store.dispatch("Projets/setProjectSelected", objet);
                    }
                  }
                }

                //var claims = tokenResult.claims;

                if (claims.superAdmin) {
                  //console.log("je suis Superadmin et Admin et connecté");
                  store.dispatch("Auth/setRoleStates", {
                    mutation: "SET_IS_SUPER_ADMIN",
                  });
                }
                if (claims.admin) {
                  //console.log("je suis Admin et connecté");
                  store.dispatch("Auth/setRoleStates", {
                    mutation: "SET_IS_ADMIN",
                  });
                }
                if (
                  claims.superviseur ||
                  claims.regionalFull ||
                  claims.regionalReadOnly
                ) {
                  // console.log("je suis Superviseur et connecté");
                  store.dispatch("Auth/setRoleStates", {
                    mutation: "SET_IS_SUPERVISEUR",
                  });
                }
                if (claims.groupe) {
                  //console.log("je suis Groupe et connecté");
                  store.dispatch("Auth/setRoleStates", {
                    mutation: "SET_IS_GROUPE",
                  });
                }

                if (claims.operateur) {
                  //console.log("je suis Opérateur et connecté");
                  store.dispatch("Auth/setRoleStates", {
                    mutation: "SET_IS_OPERATEUR",
                  });
                }
                //console.log(store.state);
              });
            /// ici se termine ///
          } else {
            // doc.data() will be undefined in this case
            console.log("No such a User! Maybe you are a groupe");
          }
        })
        .catch(function (error) {
          console.log("Error getting User:", error);
        });
      docRefGroupes
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let userFromCollectionUsers = doc.data();
            const fusionnedUser = _.merge(userFromCollectionUsers, user);
            store.dispatch("Auth/setUser", fusionnedUser);
            /// ici  commence ///
            firebase
              .auth()
              .currentUser.getIdTokenResult()
              .then((tokenResult) => {
                //console.log("je suis connecté");
                store.dispatch("Auth/setRoleStates", {
                  mutation: "SET_AUTHENTICATED",
                });
                var claims = store.state.Auth.user.roles;

                //var claims = tokenResult.claims;
                if (claims.groupe) {
                  //console.log("je suis Groupe et connecté");
                  store.dispatch("Auth/setRoleStates", {
                    mutation: "SET_IS_GROUPE",
                  });
                }
                //console.log(store.state);
              });
            /// ici se termine ///
          } else {
            // doc.data() will be undefined in this case
            /*  console.log(
              "No such a Groupe! Maybe you check in Users collection"
            ); */
          }
        })
        .catch(function (error) {
          console.log("Error getting Groupe:", error);
        });
    } else {
      console.log("je ne suis pas connecté");
      //console.log(store.state);
      next();
    }

    next();
  });
});

export default router;
